import BaseModel from './BaseModel';

export default class ReferenceFilteringInputDto extends BaseModel {
  constructor(data = {}) {
    super(ReferenceFilteringInputDto, data);
    this.searchQuery = data.searchQuery;
    this.hasTag = data.hasTag;
    this.hasKeyword = data.hasKeyword;
    this.hasAuthor = data.hasAuthor;
    this.hasPlacePublished = data.hasPlacePublished;
    this.hasDoi = data.hasDoi;
    this.publishedAfterYear = data.publishedAfterYear;
    this.publishedBeforeYear = data.publishedBeforeYear;
    this.atReviewStage = data.atReviewStage;
    this.screeningStatus = data.screeningStatus;
    this.fullTextReviewStatus = data.fullTextReviewStatus;
    this.hasFullTextPDF = data.hasFullTextPDF;
    this.dataExtractionStatus = data.dataExtractionStatus;
    this.hasComments = data.hasComments;
    this.hasCommentsByYou = data.hasCommentsByYou;
    this.joinByIntersection = data.joinByIntersection;

    // Deprecated. Will be removed as part of [LK-887].
    this.screeningState = data.screeningState;
    this.relevanceAssessments = data.relevanceAssessments;
    this.withVotesFrom = data.withVotesFrom;
  }

  hasFiltersApplied() {
    // Check if any of the fields has a value.
    return Object.values(this.asInput()).some((value) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== undefined;
    });
  }

  appliedFiltersCount() {
    return Object.values(this.asInput()).filter(Boolean).length;
  }

  /**
   * Convert object to input for GraphQL query.
   *
   * @returns {object} object that can be used as input for GraphQL query
   */
  asInput() {
    return {
      searchQuery: this.searchQuery,
      hasTag: this._cleanArrayField(this.hasTag),
      hasKeyword: this._cleanArrayField(this.hasKeyword),
      hasAuthor: this._cleanArrayField(this.hasAuthor),
      hasPlacePublished: this._cleanArrayField(
        this.hasPlacePublished
      ),
      hasDoi: this._cleanArrayField(this.hasDoi),
      publishedAfterYear: this.publishedAfterYear,
      publishedBeforeYear: this.publishedBeforeYear,
      atReviewStage: this._cleanArrayField(this.atReviewStage),
      screeningStatus: this._cleanArrayField(this.screeningStatus),
      fullTextReviewStatus: this._cleanArrayField(
        this.fullTextReviewStatus
      ),
      hasFullTextPDF: this.hasFullTextPDF,
      dataExtractionStatus: this._cleanArrayField(
        this.dataExtractionStatus
      ),
      hasComments: this.hasComments,
      hasCommentsByYou: this.hasCommentsByYou,
      joinByIntersection: this.joinByIntersection,

      // Deprecated. Will be removed as part of [LK-887].
      screeningState: this.screeningState,
      relevanceAssessments: this._cleanArrayField(
        this.relevanceAssessments
      ),
      withVotesFrom: this.withVotesFrom,
    };
  }

  /**
   * Remove empty values from array field.
   *
   * @param {array} field array field to clean
   * @returns clean array field or undefined if empty
   */
  _cleanArrayField(field) {
    const nonEmptyFields = field?.filter(Boolean);
    return nonEmptyFields?.length ? nonEmptyFields : undefined;
  }
}
